import { Link, usePage } from '@inertiajs/react';
import { Sparkles } from 'lucide-react';

export function TopBar() {
    const page = usePage();
    const { auth = {} } = page.props;
    const user = auth.user ?? null;
    const theme3InitLoad = page.props.theme3InitLoad ?? {};
    const message = theme3InitLoad.topbar?.message || 'Free delivery on orders over 1999';

    return (
        <div className="border-b border-rose-100 bg-white/95 text-slate-700 backdrop-blur">
            <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between gap-4 px-4 py-2.5 sm:px-6 lg:px-10">
                <div className="flex min-w-0 items-center gap-3">
                    <span className="inline-flex size-8 shrink-0 items-center justify-center rounded-full bg-[#f51b75] text-white shadow-[0_10px_24px_rgba(245,27,117,0.22)]">
                        <Sparkles className="size-4" />
                    </span>
                    <p className="truncate text-[10px] font-black uppercase tracking-[0.28em] text-[#d80b67] sm:text-xs">
                        {message}
                    </p>
                </div>

                <div className="hidden items-center gap-2 md:flex">
                    <Link
                        href={user ? '/account' : '/login'}
                        className="rounded-full border border-rose-100 bg-[#fff3f7] px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-[#d80b67] transition hover:-translate-y-0.5 hover:border-[#f5b4c8] hover:bg-white"
                    >
                        {user ? 'Account' : 'Login'}
                    </Link>
                    <Link
                        href="/wishlist"
                        className="rounded-full border border-rose-100 bg-[#fff3f7] px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-[#d80b67] transition hover:-translate-y-0.5 hover:border-[#f5b4c8] hover:bg-white"
                    >
                        Wishlist
                    </Link>
                </div>
            </div>
        </div>
    );
}
